import { OrderType } from '@exam-management/graphql';
import { LabelColor } from '@shared/components';

import { UserStatus } from './types';

export const USER_STATUS_TEXT: Record<UserStatus, string> = {
  ENABLED: 'Active',
  DISABLED: 'Inactive',
  INVITATION_EXPIRED: 'Expired',
  INVITATION_PENDING: 'Pending',
};

export const USER_COLOR_STATUS: Record<UserStatus, LabelColor> = {
  [UserStatus.ENABLED]: LabelColor.SUCCESS,
  [UserStatus.DISABLED]: LabelColor.GREY,
  [UserStatus.INVITATION_EXPIRED]: LabelColor.ERROR,
  [UserStatus.INVITATION_PENDING]: LabelColor.INFO,
};

export const defaultDataGridState = {
  sort: OrderType.Desc,
  field: 'lastLoginAt',
  page: 0,
  pageSize: 10,
  role: '',
};
